import { render, staticRenderFns } from "./sellers_admin.vue?vue&type=template&id=da5827ea"
import script from "./sellers_admin.vue?vue&type=script&lang=js"
export * from "./sellers_admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports